export default {
  vueWarnIgnorePartials: [
    'Computed property "locale" is already defined in Props.',
    'html is null'
  ],
};
